import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ViewPasswordComponentDef } from '@df/ui/form/view-password.component.def';

@Component({
    selector: 'view-password',
    templateUrl: './view-password.html',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewPasswordComponent extends ViewPasswordComponentDef {}
